@use "@fukuri-admins/ui/layout" as *;

.dateTimeRow {
  display: flex;
  align-items: flex-start;
  gap: spacing('8');
}

.errorText {
  color: var(--text-red, #c70036);
  font-size: 12px;
  margin-top: 4px;
}
